class SelectFillManager {
    constructor() {
        this._init()
    }
    _init() {
        this.elSelects = Array.from(document.querySelectorAll('[data-select]'))
        if(this.elSelects.length == 0) {
            return
        }
        this.elSelects.forEach(el => el.selectFill = new SelectFill(el))
    }
}

class SelectFill {
    constructor(el) {
        this._init(el)
    }
    _init(el) {
        this.el = el//document.querySelector("[data-select]")
        this.id = this.el.getAttribute('data-select')
        this.elFill = document.querySelector('[data-select-fill="' + this.id + '"]')
        if(!this.elFill) {
            return
        }
        this.el.addEventListener("change", () => this.onChange())
        setTimeout(() => {
            this.onChange()
        }, 500)
    }
    onChange() {
        this.clearFill()
        let newSelected = this.getSelectedChild()
        if(newSelected === -1) {
            //throw "data-select children html tag not supported"
            newSelected = 0
        }
        this.selectChild(newSelected)
    }
    getSelectedChild() {
        const children = Array.from(this.el.children)
        for(let i = 0; i < children.length; i++) {
          if(children[i].selected) {
              return i
          }
        }
        return -1
    }
    clearFill() {
        const children = this.elFill.children
        for(let i = 0; i < children.length; i++) {
            children[i].classList.remove('field__text-is-active')
        }
    }
    selectChild(index) {
        const children = this.elFill.children
        children[index].classList.add('field__text-is-active')
        this.el.value = this.el.options[index].value
    }
}
export default SelectFillManager